import React from 'react';

import Status, { type IStatus } from '@/components/statuses/status';
import Tombstone from '@/components/statuses/tombstone';
import { useStatusUnavailable } from '@/hooks/use-status-availability';
import { useStatus } from '@/queries/statuses/use-status';
import { useStatusMeta } from '@/stores/status-meta';

interface IStatusContainer extends Omit<IStatus, 'status'> {
  id: string;
  /** @deprecated Unused. */
  otherAccounts?: any;
}

/**
 * Legacy Status wrapper accepting a status ID instead of the full entity.
 * @deprecated Use the Status component directly.
 */
const StatusContainer: React.FC<IStatusContainer> = (props) => {
  const { id } = props;

  const { data: status } = useStatus(id, { withFilteredResults: true });

  const unavailable = useStatusUnavailable(id);
  const originalUnavailable = useStatusUnavailable(status?.reblog_id ?? undefined);
  const tombstoneId = unavailable ? id : originalUnavailable ? status?.reblog_id : undefined;
  const { deleted } = useStatusMeta(tombstoneId || id);
  if (tombstoneId)
    return (
      <Tombstone
        id={tombstoneId}
        deleted={deleted}
        onMoveUp={props.onMoveUp}
        onMoveDown={props.onMoveDown}
      />
    );

  if (status) {
    return <Status {...props} status={status} />;
  } else {
    return null;
  }
};

export { StatusContainer as default };
